/*
  Defining the block types here rather than in each block because this
  file will need to be shared with the convertor repo
*/

import { MyValue } from '../plateTypes';

/** Document Parser related definitions */
export type ArticleStructure = {
  version: Version;
  children: MyValue; // Array of blocks,
};
export const versionList = ['1.0.0', '1.1.0', '1.2.0', '1.3.0'] as const;
export const currentVersion = versionList[versionList.length - 1];
export type Version = (typeof versionList)[number];

export function isValidArticleStructure(obj: unknown): obj is ArticleStructure {
  if (!obj || typeof obj !== 'object') return false;
  return (
    'version' in obj &&
    'children' in obj &&
    // eslint-disable-next-line
    // @ts-ignore
    obj.children.length > 0
  );
}
